export default __webpack_public_path__ + "static/media/google-upload-2.41448e24.jpeg";